import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
} from '@mui/material';
import Buttons from 'components/elements/Buttons';
import { strings } from 'i18n/Strings';
import { exportFeeReport } from 'service/ReportService';
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-function-return-type
const MonthYearPicker = () => {
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const months = [
    { label: 'Jan', value: 1 },
    { label: 'Feb', value: 2 },
    { label: 'Mar', value: 3 },
    { label: 'Apr', value: 4 },
    { label: 'May', value: 5 },
    { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 },
    { label: 'Aug', value: 8 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 10 },
    { label: 'Nov', value: 11 },
    { label: 'Dec', value: 12 },
  ];

  const years = Array.from({ length: 5 }, (_, i) => year - i);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleChange = (m: number, y: number) => {
    setMonth(m);
    setYear(y);
  };

  return (
    <Grid style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
      <FormControl style={{ height: 'fit-content' }}>
        <InputLabel id="demo-simple-select-label">Month</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label="Month"
          value={month}
          onChange={(e) => {
            handleChange(Number(e.target.value), year);
          }}
        >
          {months.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl style={{ height: 'fit-content' }}>
        <InputLabel id="lable year">Year</InputLabel>
        <Select
          labelId="select=year"
          id="year-select"
          label="Year"
          value={year}
          onChange={(e) => {
            handleChange(month, Number(e.target.value));
          }}
        >
          {years.map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box sx={{ alignSelf: 'center' }}>
        <Buttons
          variant="contained"
          color="primary"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={async () => {
            const url = await exportFeeReport(month, year);
            const link = document.createElement('a');
            link.href = url as string;
            link.download = `Fee_Report_for_${month}_${year}`;
            link.click();
          }}
        >
          {strings.displayText.export}
        </Buttons>
      </Box>
    </Grid>
  );
};

export default MonthYearPicker;
